import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function MultiSigIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M19.295 12.013h-1.793a.97.97 0 0 0-.969.969v2.602c0 .535-.434.969-.969.969h-7.13a.97.97 0 0 0-.97.969v1.792c0 .536.434.97.97.97h7.543a.964.964 0 0 0 .963-.97v-1.438c0-.535.434-.915.969-.915h1.386c.535 0 .969-.434.969-.969v-3.021a.96.96 0 0 0-.97-.958M7.464 8.452c0-.536.433-.97.969-.97h7.127c.535 0 .969-.433.969-.968V4.72a.97.97 0 0 0-.97-.97H8.02a.97.97 0 0 0-.968.97v1.381c0 .536-.434.97-.97.97H4.702a.97.97 0 0 0-.97.969v3.024c0 .535.437.947.972.947h1.792c.536 0 .97-.433.97-.969zM11.155 10.129h1.722c.56 0 1.016.455 1.016 1.016v1.722c0 .56-.456 1.016-1.016 1.016h-1.722a1.017 1.017 0 0 1-1.016-1.016v-1.722c0-.561.455-1.016 1.016-1.016" />
    </Icon>
  );
}

MultiSigIcon.displayName = 'MultiSigIcon';
